import { Endpoint } from '../endpoint';

export const ReferenceValueSynonymView = new Endpoint('reference_value_synonym_view');
